import React from 'react'

import roles from 'constants/roles'
import { buildAboutUrl } from 'routing/constants'
import { timeSince } from 'utils/timeSince'

import { NotificationLink, NotificationTime, TopBarNotificationText } from './style'
import capitalize from 'utils/capitalize'

const findRoleFunc = (id) => {
  return roles.find((role) => {
    return role.value === id
  })
}

export const notificationType = {
  // eslint-disable-next-line react/display-name
  1: (data, createdAt) => {
    const findRole = findRoleFunc(data.roleApproved)
    return (
      <>
        <TopBarNotificationText>
          Your request for {findRole.label} role has been <b>Approved.</b>
        </TopBarNotificationText>
        <NotificationTime>{timeSince(Date.parse(createdAt))} ago</NotificationTime>
      </>
    )
  },
  // eslint-disable-next-line react/display-name
  2: (data, createdAt) => {
    const findRole = findRoleFunc(data.roleDeclined)
    return (
      <>
        <TopBarNotificationText>
          Your request for {findRole.label} role has been <b>Declined.</b>
        </TopBarNotificationText>
        <NotificationTime>{timeSince(Date.parse(createdAt))} ago</NotificationTime>
      </>
    )
  },
  // eslint-disable-next-line react/display-name
  3: (data, createdAt) => {
    const findRole = findRoleFunc(data.newRole)
    return (
      <>
        <TopBarNotificationText>
          Your role has been <b>Changed</b> to {findRole.label} by Secretariat.
        </TopBarNotificationText>
        <NotificationTime>{timeSince(Date.parse(createdAt))} ago</NotificationTime>
      </>
    )
  },
  // eslint-disable-next-line react/display-name
  4: (data, createdAt) => {
    return (
      <>
        <TopBarNotificationText>
          You have been invited to be co-proposer for{' '}
          <NotificationLink href={buildAboutUrl(data.siteId)}>{data.siteName}</NotificationLink>
        </TopBarNotificationText>
        <NotificationTime>{timeSince(Date.parse(createdAt))} ago</NotificationTime>
      </>
    )
  },

  // eslint-disable-next-line react/display-name
  5: (data, createdAt) => {
    return (
      <>
        <TopBarNotificationText>
          You have been removed as co-proposer for <b>{data.siteName}</b>
        </TopBarNotificationText>
        <NotificationTime>{timeSince(Date.parse(createdAt))} ago</NotificationTime>
      </>
    )
  },

  // eslint-disable-next-line react/display-name
  6: (data, createdAt) => {
    return (
      <>
        <TopBarNotificationText>
          {`${capitalize(data.firstName) } ${ capitalize(data.lastName) } left a comment for ${data.siteName}`}
        </TopBarNotificationText>
        <NotificationTime>{timeSince(Date.parse(createdAt))} ago</NotificationTime>
      </>
    )
  },

  // eslint-disable-next-line react/display-name
  7: (data, createdAt) => {
    return (
      <>
        <TopBarNotificationText>
          {`${capitalize(data.firstName) } ${ capitalize(data.lastName) } replied to your comment ${data.siteName}`}
        </TopBarNotificationText>
        <NotificationTime>{timeSince(Date.parse(createdAt))} ago</NotificationTime>
      </>
    )
  }
}
